import React from 'react';
import {Popup} from 'semantic-ui-react';

import {usePanelComments} from '../../../state/reports/usePanelComments';
import {usePanelContext} from '../../Panel/PanelContextProvider';

export const PanelViewComments = () => {
  const {panelRef, isReadOnly} = usePanelContext();
  const {panelCommentCount, openPanelComments} = usePanelComments({
    panelRef,
  });

  // Note: you need scroll all the way to the bottom of the report page
  // to trigger the panel comments query. Scroll back to a panel and then
  // you can see this button
  // Do not show this action when editing a report
  if (!isReadOnly || panelCommentCount == null || panelCommentCount <= 0) {
    return null;
  }

  return (
    <Popup
      content="View comments"
      inverted
      size="mini"
      position="top center"
      trigger={
        <div
          className="panel-comments"
          // temp use data-testid while we are
          // working on design for this button
          data-testid="view-comments-button"
          onClick={openPanelComments}>
          <span>{panelCommentCount}</span>
        </div>
      }
    />
  );
};
